
import ImageAtom from '@library/components/Atoms/Image/Image.vue'
import Links from '@library/components/Atoms/Link/Links.vue'
import Typography from '@library/components/Atoms/Typography/Typography.vue'
export default {
  components: {
    ImageAtom,
    Links,
    Typography
  },
  props: {
    labels: {
      type: Object,
      default: () => {}
    },
    data: {
      type: Object,
      default: () => {}
    },
    globals: {
      type: Object,
      default: () => {}
    },
    ctaPosition: {
      type: String,
      default: 'bottom'
    },
    titleTag: {
      type: String,
      default: 'h4'
    }
  }
}
